
import React from 'react';

const PrivacyDisclaimer = () => {
  return (
    <p className="text-sm text-gray-500 text-center">
      Door het formulier in te vullen ga je akkoord met onze <a href="/privacybeleid" className="text-brand-blue underline hover:no-underline">privacyverklaring</a>.
    </p>
  );
};

export default PrivacyDisclaimer;
